import useQuestionPreview from 'chameleon-src/components/QuestionPreview/hooks/useQuestionPreview';
import React from 'react';

const QuestionsWithPreview = ({ questionByTagData }) => {
  const itemsWithReference = React.useMemo(
    () =>
      questionByTagData.map(({ learnosityItemReference, itemId }) => ({
        learnosity_item_reference: learnosityItemReference,
        item_id: itemId,
      })),
    [questionByTagData],
  );

  const [
    {
      hoverProps: questionPreviewProps,
      preview: questionPreview,
      previewContainer: questionPreviewContainer,
    },
  ] = useQuestionPreview({
    isAvailable: true,
    items: [itemsWithReference[0]],
    dynamicItems: itemsWithReference,
    hoveredItemParent: 'li',
    containerOffsetX: 80,
    containerOffsetY: 0,
    containerPlacement: 'top',
    shouldResetApp: false,
    questionsContainer: '.performanceTiersModal',
  });

  const getColorByPercentage = (avgScorePercentage) => {
    // Note: Move this to a constant if this mapping is required in another place
    const colorToScoreThresholdsMap = [
      { threshold: 25, color: 'tier1' },
      { threshold: 50, color: 'tier2' },
      { threshold: 75, color: 'tier3' },
      { threshold: 101, color: 'tier4' },
    ];
    const { color } = colorToScoreThresholdsMap.find(
      ({ threshold }) => avgScorePercentage < threshold,
    );
    return color;
  };

  return (
    <div className="performanceTiersModal">
      <div className="performanceTiersModalBody">
        <div className="hover-question-parent">
          <section className="flex justify-between text-gray-600 font-medium text-12">
            <div>QUESTIONS</div>
            <div>AVERAGE PERFORMANCE</div>
          </section>
          <section className="text-gray-900 text-base font-normal">
            <ul className="grid list-none p-0 pr-6 gap-y-4 overflow-y-auto max-h-47">
              {questionByTagData.map(
                ({ title, avgScorePercentage, learnosityItemReference }) => (
                  <li
                    key={`${title}-${avgScorePercentage}-${Math.random()}`}
                    className="flex justify-between cursor-pointer"
                    {...questionPreviewProps}
                    data-reference={learnosityItemReference}
                  >
                    <div className="preview-player-container">
                      <div>{title}</div>
                      <span className="flex justify-between gap-x-2 w-25">
                        <div
                          className={`rounded-full h-8 w-8 ${getColorByPercentage(
                            avgScorePercentage,
                          )}`}
                        />
                        {avgScorePercentage}%
                      </span>
                    </div>
                  </li>
                ),
              )}
            </ul>
          </section>
        </div>
        {React.cloneElement(questionPreviewContainer, {
          children: questionPreview,
        })}
      </div>
    </div>
  );
};

export default QuestionsWithPreview;
